import * as React from 'react';
import { observer } from 'mobx-react';

import { useUserStore } from 'stores/index';
import Avatar from 'shared/newComponents/user/Avatar';
import managerImg from 'shared/img/managerImg.png';
import {
  AvatarSize,
  AvatarType
} from 'shared/newEntities/components/user/Avatar';

type Props = {
  className?: string;
  size?: AvatarSize;
};

export const AvatarContainer: React.FC<Props> = ({
  className,
  size = AvatarSize.m
}: Props) => {
  const userStore = useUserStore();

  const name = userStore.user?.name?.length ? userStore.user.name : null;

  return (
    <Avatar
      className={className}
      type={name ? AvatarType.name : AvatarType.img}
      content={name ?? managerImg}
      size={size}
    />
  );
};

export default observer(AvatarContainer);
